/**
 * Returns a promise that waits the specified number of milliseconds before resolving.
 *
 * @param ms The number of milliseconds to wait.
 */
export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
